'use strict';
const {sdkTextElement, sdkMessageElement, sdkDisplayElement, localizeSdkElement} = require('../i18n/sdk-text');
 // Shared by the real readonly SDK and the separately labelled local preview.
// Only server-confirmed activity progress selects the next step; no fallback1.
const {activityPresentation, MAX_REWARD_TITLE, MAX_REWARD_NOTE} = require('./activity-presentation.js');

function limitedSteps(items, activity) {
  const rows = items.filter(p => p.kind === 'limited').slice().sort((a, b) => a.step - b.step);
  if (rows.length !== 6 || rows.some((p, i) => p.step !== i + 1)) throw Error('INVALID_LIMITED_STEPS');
  const valid = activity && activity.enabled === true && typeof activity.completed === 'boolean' && Number.isSafeInteger(activity.nextStep) && activity.nextStep >= 1 && activity.nextStep <= 7;
  const complete = !!valid && activity.completed;
  const current = valid && !complete && activity.nextStep <= 6 ? rows[activity.nextStep - 1] : null;
  return {
    rows: rows.map(p => ({ ...p,
      state: complete ? 'completed' : current ? p.step < current.step ? 'completed' : p.step === current.step ? 'current' : 'locked' : 'unpublished'
    })),
    current,
    complete
  };
}

function createLimitedRenderer(React) {
  const h = React.createElement;
  return function renderLimitedPackages({
    items,
    activity,
    activityClock,
    readOnly = false,
    busy = false,
    quote = null,
    priceLabel = null,
    slogan,
    onChoose,
    onCheckout,
    onTab
  }) {
    const schedule = activityPresentation(activity, activityClock),
          progress = limitedSteps(items, activity),
          current = progress.current,
          currentQuote = current && quote && quote.skuId === current.skuId && activity && quote.activityId === activity.activityId ? quote : null;

    const formatMoney = q => new Intl.NumberFormat('zh-HK', {
      style: 'currency',
      currency: q.currency
    }).format(Number(q.amountMinor) / 100);

    const canChoose = !!current && schedule.active && !readOnly && !busy && activity.purchasingEnabled === true;
    return h(React.Fragment, null, h('section', {
      className: 'opcards-hero opcards-limited-hero opcards-activity-hero'
    }, h('div', {className: 'opcards-activity-heading'},
      h('small', {className: 'opcards-activity-eyebrow'}, h('span', {className: 'opcards-activity-dot', 'aria-hidden': true}), schedule.active ? sdkTextElement('限時活動進行中') : sdkTextElement('限時典藏合輯')),
      h('h1', null, sdkTextElement(MAX_REWARD_TITLE)), h('p', {className: 'opcards-value-note'}, sdkTextElement(slogan)),
      h('p', {className: 'opcards-reward-note'}, sdkTextElement(MAX_REWARD_NOTE))),
      h('div', {className: 'opcards-activity-countdown' + (schedule.active ? '' : ' is-inactive')},
        h('span', {className: 'opcards-countdown-label'}, schedule.active ? sdkTextElement('距離本期結束') : schedule.phase === 'future' ? sdkTextElement('活動尚未開始') : schedule.phase === 'ended' ? sdkTextElement('本期活動已結束') : activity ? sdkTextElement('活動已結束或暫停') : sdkTextElement('活動尚未開放')),
        localizeSdkElement(h('strong', {
  role: 'timer',
  'aria-live': 'off',
  'aria-label': '活動剩餘時間'
}, sdkDisplayElement(schedule.countdown,['{{v0}}天 {{v1}}'])), {
  "aria-label": ["\u6D3B\u52D5\u5269\u9918\u6642\u9593"]
}),
        schedule.endLabel && h('small', null, sdkTextElement('結束時間 '), h('time', {dateTime: new Date(schedule.endAt).toISOString()}, schedule.endLabel), sdkTextElement('（香港時間）'))),
      h('div', {className: 'opcards-activity-rules'}, h('span', null, sdkTextElement('6 步限定合輯')), h('span', null, sdkTextElement('每期每人限一輪')), h('span', null, sdkTextElement('依序解鎖 · 加贈卡包'))),
      h('p', {className: 'opcards-activity-description'}, readOnly ? sdkTextElement('卡包預覽 · 目前尚未開售或開放揭卡。') : sdkTextElement('按順序購買第 1 至 6 步；付款後可於「我的卡包」揭開。'))), h('div', {
      className: 'opcards-tabs'
    }, h('button', {
      type: 'button',
      disabled: busy,
      onClick: () => onTab('permanent'),
      'aria-pressed': false
    }, sdkTextElement('常駐卡包')), h('button', {
      type: 'button',
      disabled: busy,
      onClick: () => onTab('limited'),
      'aria-pressed': true
    }, sdkTextElement('限時合輯'))), h('div', {
      className: 'opcards-step-scroll'
    }, localizeSdkElement(h('ol', {
  className: 'opcards-step-track',
  'aria-label': '限時卡包六步進度'
}, progress.rows.map(p => h('li', {
  key: p.skuId,
  className: 'opcards-step ' + p.state,
  'aria-current': p.state === 'current' ? 'step' : undefined
}, h('span', {
  className: 'opcards-step-number'
}, p.state === 'completed' ? '✓ ' + p.step : sdkMessageElement("\u7B2C {{v0}} \u6B65", {
  v0: p.step
})), h('strong', null, sdkMessageElement("{{v0}} \u5305", {
  v0: p.paidPacks
})), p.giftPacks > 0 ? h('b', {
  className: 'opcards-step-gift'
}, sdkMessageElement("\u9001 {{v0}} \u5305", {
  v0: p.giftPacks
})) : h('span', {
  className: 'opcards-step-spacer',
  'aria-hidden': true
}, ' '), h('small', null, p.state === 'completed' ? sdkTextElement('已完成') : p.state === 'current' ? sdkTextElement('當前') : p.state === 'locked' ? sdkTextElement('待解鎖') : sdkTextElement('未開放'))))), {
  "aria-label": ["\u9650\u6642\u5361\u5305\u516D\u6B65\u9032\u5EA6"]
})), progress.complete ? h('section', {
      className: 'opcards-limited-finished',
      role: 'status'
    }, h('strong', null, sdkTextElement('本期六步已完成')), h('p', null, sdkTextElement('本期每人限一輪；已取得的卡包可在「我的卡包」查看。'))) : !current ? h('p', {
      className: 'opcards-progress',
      role: 'status'
    }, sdkTextElement('尚未發佈活動排程；目前只供查看。')) : h('section', {
      className: 'opcards-current-step'
    }, h('div', {
      className: 'opcards-current-detail'
    }, h('span', {
      className: 'opcards-foil',
      'aria-hidden': true
    }, 'OP'), h('div', null, h('small', null, sdkMessageElement("\u7576\u524D\u7B2C {{v0}} \u6B65", {
  v0: current.step
})), h('strong', null, sdkMessageElement("{{v0}} \u5361\u5305", {
  v0: current.paidPacks
})), current.giftPacks > 0 && h('b', {
      className: 'opcards-bonus'
    }, sdkMessageElement("\u53E6\u8D08 {{v0}} \u5305", {
  v0: current.giftPacks
})), h('span', null, current.name))), h('div', {
      className: 'opcards-current-action'
    }, h('strong', {
      className: 'opcards-current-price'
    }, currentQuote ? formatMoney(currentQuote) : readOnly ? sdkTextElement('尚未開售') : priceLabel || sdkTextElement('選擇後確認價格')), h('button', {
      type: 'button',
      className: 'opcards-primary',
      disabled: readOnly || busy || !schedule.active || !currentQuote && !canChoose,
      onClick: () => currentQuote ? onCheckout() : onChoose(current)
    }, readOnly ? sdkTextElement('尚未開售') : schedule.phase === 'ended' ? sdkTextElement('本期活動已結束') : !schedule.active ? sdkTextElement('活動未開放') : currentQuote ? sdkTextElement('選擇付款方式') : sdkMessageElement("\u9078\u64C7\u7B2C {{v0}} \u6B65", {
  v0: current.step
})))));
  };
}

module.exports = {
  limitedSteps,
  createLimitedRenderer
};
